// Copyright 2019 Drivetrain Hub LLC
// Configure icons for use with DhIcon.vue throughout Vue app.
// https://vuejs.org/v2/guide/plugins.html

// Cannot type hint PluginObject without losing variable resolution.
// eslint-disable-next-line no-unused-vars
import { PluginFunction } from "vue";
import "../assets/icons";

/**@alias $icons */
const Icons = {
  // FILE
  fileNew: "el-icon-document-add",
  fileOpen: "el-icon-folder-opened",
  fileCopy: "el-icon-document-copy",
  fileDelete: "el-icon-delete",
  fileLink: "el-icon-link",
  fileEdit: "el-icon-edit",
  fileAttach: "el-icon-paperclip",
  // PLM
  share: "el-icon-share",
  lock: "svg-lock-on",
  unlock: "svg-lock-off-b",
  // BUTTON BAR
  modelOpen: "svg-folder-files",
  modelInfo: "el-icon-info",
  gearExternal: "svg-gear-a",
  gearInternal: "svg-gear-b-internal",
  partShaft: "svg-shaft2",
  partCarrier: "svg-carrier-circles2",
  partGround: "ground",
  propsMicro: "svg-mesh",
  propsStandards: "svg-globe",
  propsAtoms: "atoms",
  propsCustom: "svg-curly-brackets",
  toolBasicRack: "svg-basic-rack",
  toolHob: "svg-saw-circular-b",
  toolShaper: "svg-shaper",
  toolMill: "svg-saw-circular",
  libGear: "svg-gears3",
  libTool: "svg-tools",
  assmMove: "move",
  assmPosition: "svg-gps-indicator",
  assmConnect: "svg-link",
  assmConfig: "el-icon-s-operation",
  calculator: "svg-calculator",
  reportGears: "svg-report-gears",
  expPrint: "svg-print-3d",
  cubeSolid: "cube-solid",
  expData: "el-icon-document",
  // CONNECTIONS
  connectRatio: "svg-gears2",
  connectRevolute: "rotate-cw",
  connectWeld: "circle-x",
  connectClutch: "circle-split",
  // ANALYSIS
  tableGrid: "svg-table-grid",
  powerload: "rotate-ccw",
  powerflow: "svg-powerflow",
  vibration: "svg-vibration",
  pause: "pause",
  play: "play",
  colorPalette: 'color-palette',
  cubeGrid: "cube-grid",
  // BUILD
  millingGear: "milling-gear",
  factory: "factory",
  userTie: "user-tie",
  setSquare: "svg-set-square",
  cubeTriangles: "cube-triangles",
  // OTHER
  chatBox: "el-icon-chat-dot-square",
};

/** @type {PluginFunction} */
Icons.install = function(Vue) {
  Vue.prototype.$icons = Icons;
};

export default Icons
